var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getSettings.adType)?_c('div',{staticClass:"C-block-type-26"},[_c(_vm.getSettings.component,{tag:"component",attrs:{"ad-type":_vm.getSettings.adType,"settings":_vm.getSettings.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }